import request from '@/utils/request'

export function getPlayMethod() {
    return request({
        url: 'api/playMethod',
        method: 'get'
    })
}

export function del(id) {
    return request({
        url: 'api/playMethod/' + id,
        method: 'delete'
    })
}

export function edit(data) {
    return request({
        url: 'api/playMethod',
        method: 'put',
        data
    })
}

export function add(data) {
    return request({
        url: 'api/playMethod',
        method: 'post',
        data
    })
}

export function getAllSettings() { //查询词库全局设置
    return request({
        url: 'api/globalOption/allSettings',
        method: 'get'
    })
}

export function putAllSettings(data) { //更新词库全局设置
    return request({
        url: 'api/globalOption/allSettings',
        method: 'put',
        data
    })
}